import { type DeviceOperationalState } from '@/__generated__/graphql';
import { getDeviceOperationalStateAttributes } from '@/utils/attributes/deviceOperationalState';
import { useLingui } from '@lingui/react';
import {
  Box,
  Tooltip,
  type BoxProps,
  type SvgIconProps,
  type TypographyProps,
} from '@mui/material';
import { type FC } from 'react';
import TruncatedTypography from './TruncatedTypography';
import { msg } from '@lingui/macro';

interface Props {
  state: DeviceOperationalState;
  slotProps?: {
    root?: BoxProps;
    icon?: SvgIconProps;
    typography?: TypographyProps;
  };
}

export const DeviceOperationalStateDisplay: FC<Props> = ({ state, slotProps }) => {
  const { i18n, _ } = useLingui();
  const { label, Icon, fgcolor, bgcolor, borderColor } = getDeviceOperationalStateAttributes(
    state,
    i18n,
  );

  return (
    <Tooltip title={_(msg`Estado operacional`)} placement="top">
      <Box
        display="grid"
        sx={{ placeItems: 'center' }}
        gap={1}
        p={0.5}
        border={1}
        borderRadius={6}
        borderColor={borderColor}
        color={fgcolor}
        bgcolor={bgcolor}
        {...slotProps?.root}
      >
        <Box display="flex" alignItems="center" gap={1} px={2}>
          <Icon sx={{ fontSize: 20 }} {...slotProps?.icon} />
          <TruncatedTypography
            color="inherit"
            fontWeight="medium"
            fontSize="medium"
            {...slotProps?.typography}
            sx={{
              textRendering: 'geometricPrecision',
              ...slotProps?.typography?.sx,
            }}
          >
            {label}
          </TruncatedTypography>
        </Box>
      </Box>
    </Tooltip>
  );
};
